import React from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import { useTranslation } from "react-i18next";
import selectStyles from "./styles";

export default function AsyncCreatableSelectWrapper({
  createLabel = "common.create",
  ...otherProps
}) {
  const { t } = useTranslation();
  return (
    <AsyncCreatableSelect
      styles={selectStyles}
      formatCreateLabel={(inputValue) => `${t(createLabel)} "${inputValue}"`}
      {...otherProps}
    />
  );
}
